import {Fragment} from 'react';
import {Dialog, Transition} from '@headlessui/react';
import {EnvelopeIcon} from '@heroicons/react/24/outline';
import {Button} from '../../components/Button';

export interface InviteOnlyModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function InviteOnlyModal(props: InviteOnlyModalProps) {
  return (
    <Transition.Root show={props.open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => props.setOpen(false)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-neutral-dark bg-opacity-75 transition-opacity backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-2xl bg-surface px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                <div>
                  <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-subtle">
                    <EnvelopeIcon className="h-8 w-8 text-brand" aria-hidden="true" />
                  </div>
                  <div className="mt-4 text-center sm:mt-6">
                    <Dialog.Title as="h3" className="text-lg  leading-6 text-main">
                      Invitation Only
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm  text-muted">
                        Thanks for stopping by! TripVibes is currently invite-only. If you have an
                        invite link, please use that to sign up. Hope to see you soon!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-6 sm:mt-8">
                  <Button
                    type="button"
                    variant="primary"
                    fullWidth
                    onClick={() => props.setOpen(false)}
                  >
                    Got it
                  </Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
